import type { SVGProps } from "react";
export function Loading(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <g clipRule="evenodd" fill="currentColor" fillRule="evenodd">
        <path
          d="m1.99775 7.99996c0 3.31374 2.6816 6.00004 5.98953 6.00004 3.30792 0 5.98952-2.6863 5.98952-6.00004 0-3.31371-2.6816-6-5.98952-6-3.30793 0-5.98953 2.68629-5.98953 6zm5.98953-7.333334c-4.04302 0-7.320532 3.283244-7.320532 7.333334 0 4.05004 3.277512 7.33334 7.320532 7.33334s7.32052-3.2833 7.32052-7.33334c0-4.05009-3.2775-7.333334-7.32052-7.333334z"
          opacity={0.2}
        />
        <path d="m7.32178 1.33329c0-.368187.29795-.666664.6655-.666664 4.44562 0 7.68222 3.680034 7.31822 8.055364-.0305.36692-.3522.63958-.7185.609-.3662-.03058-.6384-.35281-.6079-.71973.3015-3.62466-2.3514-6.6113-5.99182-6.6113-.36755 0-.6655-.29848-.6655-.66667z" />
      </g>
    </svg>
  );
}
